import setCookie from '@/utils/setCookie'

const deleteCookie = (name: string) => {
    setCookie(name, '', undefined, NaN)
}

export default deleteCookie
